import { createSlice } from '@reduxjs/toolkit';

const SlideToggleSlice = createSlice({
    name: 'Slide Toogle',
    initialState: false,
    reducers: {
        ToggleSlide: (state) => {
            return state = !state;
        },
    },
});

export const { ToggleSlide } = SlideToggleSlice.actions;
export default SlideToggleSlice.reducer;
